import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import logo from "../assets/image 50.svg";
import { useNavigate } from "react-router-dom";
import bg from "../assets/homebg.png";
import homepage from "../assets/AppFront.png";
import dotdot from "../assets/dotdot.png";
import { TailSpin } from "react-loader-spinner";
import eaii from "../assets/logo.jpg";

const Home = ({ languageDropdown, getTranslation }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleButtonClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      navigate("/conversation");
    }, 1000);
  };

  return (
    <div className="relative min-h-screen w-screen overflow-hidden bg-gray-50 flex flex-col justify-between">
      {/* Background Image */}
      <img
        loading="lazy"
        src={bg}
        alt="Background"
        className="absolute right-0 top-0 w-full h-full object-cover z-0"
      />

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <TailSpin
            height="80"
            width="80"
            color="#FFFFFF"
            ariaLabel="loading"
          />
        </div>
      )}

      {/* Header */}
      <div
        className={`relative z-20 ${
          isLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        <div className="relative flex justify-between items-center px-4 sm:px-8 md:px-20 py-4 z-30">
          <div className="flex items-center gap-3 sm:gap-5 text-lg sm:text-xl text-[#161A61] font-bold">
            <img
              src={logo}
              alt="Logo"
              className="w-10 sm:w-14 h-10 sm:h-14 object-contain rounded-full border-4 border-white shadow-lg"
            />
            <div>{getTranslation("title")}</div>
            
          </div>
          {/* Language Dropdown */}
          <div className="relative z-50 flex items-center">{languageDropdown}
          <img
              src={eaii}
              alt="EAII Logo"
              className="w-10 sm:w-14 h-10 sm:h-14 object-contain rounded-full border-4 border-white shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative flex flex-col  lg:flex-row justify-center items-center h-full px-5 sm:px-10 md:px-20 z-10">
        {/* Text Section (Centered) */}
        <div className="lg:w-1/2 flex flex-col mt-32  items-start justify-center space-y-5 sm:space-y-7 text-start">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#161A61]">
            {getTranslation("welcome")}
          </h1>

          <p className="text-[#2f2f2f] text-sm sm:text-base md:text-lg  ">
            {getTranslation("description")}
          </p>

          <button
            onClick={handleButtonClick}
            className="px-5 sm:px-6 py-2 sm:py-3 bg-[#161A61] text-white rounded-md hover:bg-[#252a7c] transition flex items-center justify-center gap-2 text-sm sm:text-base"
          >
            {getTranslation("start")}{" "}
            <FaArrowRight className="w-4 sm:w-5 h-4 sm:h-5" />
          </button>
        </div>

        {/* Homepage Image */}
        <div className="mt-8 lg:mt-0 lg:ml-10 lg:w-1/2 flex flex-col items-center relative z-10">
          <img
            src={homepage}
            alt="Homepage"
            className="w-[70%] sm:w-[90%] md:w-[500px] md:h-auto object-contain rounded-xl"
          />
          <img
            src={dotdot}
            alt="Dotdot"
            className="-mt-24 sm:-mt-40 -z-10 w-1/2 sm:w-auto"
          />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-100 py-3 flex justify-center items-center gap-2 text-center mt-auto">
  <p className="text-gray-700 text-sm font-medium">
    {getTranslation("providedBy")} Ethiopian Artificial Intelligence Institute © 2025
  </p>
</footer>

    </div>
  );
};

export default Home;
